import React from 'react'
import ReactDOM from 'react-dom'
import './Default.css'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { StylesProvider, createGenerateClassName, ThemeProvider } from '@material-ui/core/styles'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import theme from 'config/theme'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { AuthProvider } from './context'
import 'moment/locale/es'

moment.locale(`es`)




const generateClassName = createGenerateClassName({
  disableGlobal: true,
  productionPrefix: `SERNATUR-`,
})

ReactDOM.render(
  <AuthProvider>
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider libInstance={moment} locale={`es`} utils={MomentUtils}>
          <App />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </StylesProvider>
  </AuthProvider>,
  document.getElementById(`root`),
)



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
